import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import '../../assets/css/admin/allcourses.css';
import Swal from 'sweetalert2';
import axios from 'axios';

const AllScholarships = () => {
    const [Scholarships, setScholarships] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredScholarships, setFilteredScholarships] = useState([]);

    useEffect(() => {
        fetchScholarships();
    }, []);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredScholarships(Scholarships);
        } else {
            const results = Scholarships.filter((scholarship) =>
                (scholarship.sProgrammeName && scholarship.sProgrammeName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (scholarship.country && scholarship.country.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (scholarship.university && scholarship.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (scholarship.institutePhone && scholarship.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (scholarship.instituteEmail && scholarship.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setFilteredScholarships(results);
        }
    }, [searchTerm, Scholarships]);

    const fetchScholarships = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/scholarships/all');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setScholarships(data);
            setFilteredScholarships(data); // Initialize filteredScholarships with all scholarships
        } catch (error) {
            console.error('Error fetching Scholarships:', error);
            Swal.fire({
                title: "Error!",
                text: "Failed to fetch scholarships. Please check if the server is running.",
                icon: "error"
            });
        }
    };

    const handleDelete = (scholarshipId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this scholarship?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`https://api.myskills.lk/scholarships/delete/${scholarshipId}`)
                    .then((response) => {
                        // Update local state after successful deletion
                        const updatedScholarships = Scholarships.filter(scholarship => scholarship.id !== scholarshipId);
                        setScholarships(updatedScholarships);
                        setFilteredScholarships(updatedScholarships);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The scholarship has been deleted.",
                            icon: "success"
                        });
                    })
                    .catch((err) => {
                        console.error("Error deleting scholarship:", err);
                        let errorMessage = "Failed to delete the scholarship.";
                        if (err.response && err.response.data && err.response.data.message) {
                            errorMessage = err.response.data.message;
                        }
                        Swal.fire({
                            title: "Error!",
                            text: errorMessage,
                            icon: "error"
                        });
                    });
            }
        });
    };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL SCHOLARSHIPS</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table> 
                    <thead>
                                <tr>
                                    <th>Scholarship Programme Name</th>
                                    <th>Country</th>
                                    <th>Offered By</th>
                                    <th>Closing Date </th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredScholarships.length > 0 ? (
                                    filteredScholarships.map((scholarship) => (
                                        <tr key={scholarship.id}>
                                            <td>{scholarship.sProgrammeName}</td>
                                            <td>{scholarship.country}</td>              
                                            <td>{scholarship.university}</td>
                                            <td>{new Date(scholarship.closingDate).toLocaleDateString('en-CA')}</td>
                                            <td>{scholarship.institutePhone}</td>
                                            <td>{scholarship.instituteEmail}</td>
                                            <td>
                                                {scholarship.instituteWebsite ? (
                                                    <a href={scholarship.instituteWebsite} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                                ) : (
                                                    <span style={{ color: '#999' }}>No Website</span>
                                                )}
                                            </td>
                                            <td id='action-buttons'>
                                                {/* <a href="#!" id='man-details' onClick={() => handleEdit(course.id)}>EDIT</a> */}
                                                <a href="#!" id='del-details' onClick={(e) => handleDelete(scholarship.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center' }}>No scholarships found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllScholarships;
